import { FC, useContext } from 'react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';
import HandelseForm from 'components/utkast/handelseForm/HandelseForm';
import { EnskiltFormValues, HandelseFormValues } from 'components/utkast/utkastRegistration/UtkastFormSchema';
import { UpphovsmanContext } from 'components/utkast/utkastRegistration/UtkastRegistration';

import { HandelseTyp } from 'models';

import { HandelseTypEnum } from 'enums';

import { FormikErrors, FormikTouched, useFormikContext } from 'formik';

interface HandelseSectionProps {
  handelsetyp: HandelseTypEnum;
  handelsetyper: Array<HandelseTyp>;
  labelText: string;
  showLegend?: boolean;
}

const HandelseSection: FC<HandelseSectionProps> = ({ handelsetyp, handelsetyper, showLegend, labelText }) => {
  const { values, setFieldValue, errors, touched } = useFormikContext<EnskiltFormValues>();

  const getHandelseTypNamn = (avHandelseTyp: HandelseTypEnum): string =>
    handelsetyper.find((h) => h.handelsetyp === avHandelseTyp)?.namn || '';

  const { selectedUpphovsman, setSelectedUpphovsman } = useContext(UpphovsmanContext);

  return (
    <>
      {values.handelser.map((handelse, index) => {
        if (handelse.handelsetyp === handelsetyp) {
          return (
            <DrawerSection key={handelsetyp + index} className="tw-p-2 md:tw-p-4">
              <fieldset>
                {showLegend && (
                  <legend className="tw-heading-md tw-mb-4 tw-ml-2 tw-pt-2">
                    {getHandelseTypNamn(handelse.handelsetyp)}
                  </legend>
                )}
                <HandelseForm
                  newUpphovsmanSelected={(newUpphovsman) =>
                    setSelectedUpphovsman((current) => [...current, newUpphovsman])
                  }
                  selectedUpphovsman={selectedUpphovsman}
                  name={`handelser[${index}]`}
                  labelText={labelText}
                  handelseFormValue={values.handelser[index]}
                  errors={(errors.handelser && errors.handelser[index]) as FormikErrors<HandelseFormValues>}
                  touched={(touched.handelser && touched.handelser[index]) as FormikTouched<HandelseFormValues>}
                  setFieldValue={setFieldValue}
                />
              </fieldset>
            </DrawerSection>
          );
        }
      })}
    </>
  );
};

export default HandelseSection;
